import { useState, useEffect, Fragment } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate, useParams, Link } from 'react-router-dom';
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';

import { editarBreadcrumb } from '../../actions/breadcrumb';
import { setAlert } from '../../actions/alert';
import { obtenerAsesoria, limpiarAsesoria, editarAsesoria } from '../../actions/asesorias';

const EditarAsesoria = () => {

    let rutasBread = [
        {
            activo: false,
            nombre: 'Asesorías',
            path: '/asesorias'
        },
        {
            activo: true,
            nombre: 'Editar asesoría',
            path: '/asesorias/editar'
        }
    ];

    const dispatch = useDispatch();

    const navigate = useNavigate();

    const { id } = useParams();

    const { detalles } = useSelector(state => state.asesorias);

    const [asesoriaData, setAsesoriaData] = useState({
        id: null,
        motivo: null, 
        fecha: null, 
        descripcion: null
    });

    /* Editar asesoría */
    const handleInputChange = ({ target }) => {
        setAsesoriaData({
            ...asesoriaData,
            [target.name]: target.value
        });
    }

    const handleDatePicker = (name, value) => {
        setAsesoriaData({
            ...asesoriaData,
            [name]: value
        });
    }

    const handleEditarAsesoria = async () => {
        if(asesoriaData.motivo && asesoriaData.fecha){
            await dispatch(editarAsesoria(asesoriaData));

            await navigate("/asesorias");
        }else{
            await dispatch(setAlert('Todos los campos son obligatorios', 'danger'));
        }
    }

    useEffect(() => {
        dispatch(limpiarAsesoria());

        return () => {
            dispatch(limpiarAsesoria());
        }
    }, []);

    useEffect(() => {
        dispatch(obtenerAsesoria(id));

        if(id){
            rutasBread[1].path = rutasBread[1].path + id;

            dispatch(editarBreadcrumb(rutasBread));
        }
    }, [id]);

    useEffect(() => {
        setAsesoriaData({
            ...asesoriaData,
            id: detalles?._id,
            motivo: detalles?.motivo,
            fecha: detalles?.creacion,
            descripcion: detalles?.descripcion
        });
    }, [detalles]);

    useEffect(() => {
        dispatch(editarBreadcrumb(rutasBread));
    }, [rutasBread]);

    return (
        <Fragment>
            <div className="row">
                <div className="col-md-10 offset-md-1 pb-4">
                    <h3 className="title-section my-5">Editar asesoría</h3>
                
                    <div className="row">
                        <div className="col-md-9 form-group mb-3">
                            <div className="input-group">
                                <div className="form-floating">
                                    <input type="text" className="form-control" placeholder="Motivo" id="motivo" name="motivo" value={asesoriaData.motivo} onChange={e => handleInputChange(e)}/>
                                    <label htmlFor="motivo">Motivo</label>
                                </div>
                            </div>
                        </div>
                        
                        <div className="col-md-3 form-group mb-3">
                            <div className="input-group">
                                <div className="form-floating">
                                    <DatePicker
                                        id="fecha"
                                        name="fecha"
                                        className="form-control text-center input-datepícker"
                                        dateFormat="dd/MM/yyyy"
                                        locale="es-ES"
                                        peekNextMonth
                                        showMonthDropdown
                                        showYearDropdown
                                        dropdownMode="select"
                                        selected={ asesoriaData.fecha != null ? new Date(asesoriaData.fecha) : '' }
                                        onChange={ date => handleDatePicker('fecha', date) }
                                    />
                                    <label className="label-datepicker" htmlFor="fecha">Fecha de creación</label>
                                </div>
                            </div>
                        </div>
                        
                        <div className="col-md-12 form-group mb-3">
                            <div className="input-group">
                                <div className="form-floating">
                                    <textarea className="form-control textareaCampo" placeholder="Descripción" id="descripcion" name="descripcion" value={asesoriaData.descripcion} onChange={e => handleInputChange(e)}></textarea>
                                    <label htmlFor="descripcion">Descripción</label>
                                </div>
                            </div>
                        </div>
                    </div>
                    
                    <div className="row">
                        <div className="col-md-12 my-5">
                            <button className="btn btn-success float-end" onClick={handleEditarAsesoria}>Guardar</button>
                            <Link to='/asesorias'><button className="btn btn-danger float-end me-2">Cancelar</button></Link>
                        </div>
                    </div>
                </div>
            </div>
        </Fragment>
    )
}

export default EditarAsesoria;